import React from "react";

const SuscripcionCard = ({ plan, price, img, handleSubscription, features }) => {
    return (
        <div className="card-container">
            <div className="plan card-flip">
                <div className="card-front">
                    <div className="plan-title">
                        <img src={img} alt="Plan Básico" />
                    </div>
                    <div className="plan-content"><span>{price}</span> €/año</div>
                    
                </div>
                <div className="card-back">
                    <h4 className="text-center mb-4">Características {plan}</h4>
                    <ul>
                        {features.map((feature, index) => (
                            <li key={index}>{feature}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="plan-button m-auto">
                <div className="button" onClick={()=>{handleSubscription(price, plan)}}>Adquirir</div>
            </div>
        </div>
    );
}

export default SuscripcionCard;